import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

/**
* class HSN.CouponModal
*
* Encapsulates the functionality of a modal dialog that contains coupon information.
**/
HSN.CouponModal = (function (_super) {
    __extends(CouponModal, _super);

    /**
    * new HSN.CouponModal()
    **/
    function CouponModal() {
        this.elementName = '#';
        this.name = 'HSN.CouponModal';

        return CouponModal.__super__.constructor.call(this);
    }

    CouponModal.prototype._hide = function () {
    };

    /**
    * HSN.CouponModal#Show(parentcouponcode) -> void
    * Display the modal and load in the information for the given coupon identifier.
    **/
    CouponModal.prototype._show = function (url) {
        var __scope = this;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            success: function (data, status, xhr) {
                __scope.Root.removeClass('loading');

                __scope.DisplayModal(data, 0);
            },
            error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    CouponModal.prototype.DisplayModal = function (data, time) {
        var __scope = this;

        this.Content.showHtml(data, time,
            function () {
                __scope.Center();
                __scope.Content.animate({ opacity: 1 });
            },
            function () {
                //__scope.Center();
            });
    };

    return CouponModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/CouponModal.js